'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserCommission } from '../../Entities/User/UserCommission';
import { UserCommissionCollection } from '../../Collections/User/UserCommissionCollection';

export class UserCommissionRepository extends CoreRepository {
  public createUserCommission(userId: number, payload: object = {}) {
    return this.webAPI.createUserCommission(userId, payload).then((response) => {
      const userCommission = new UserCommission();
      userCommission.hydrate(response);

      return userCommission;
    });
  }

  public updateUserCommission(userId: number, scheduleId: number, payload: object = {}) {
    return this.webAPI.updateUserCommission(userId, scheduleId, payload).then((response) => {
      const userCommission = new UserCommission();
      userCommission.hydrate(response);

      return userCommission;
    });
  }

  public getUserCommission(
    userId: number,
    companyId: number,
    planId: number,
    options: object = null
  ) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getUserCommission(userId, companyId, planId, options).then((response) => {
      if (!response) {
        return false;
      }

      const userCommission = new UserCommission();
      userCommission.hydrate(response);

      return userCommission;
    });
  }

  public getUserCommissions(
    userId: number,
    type: string,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserCommissions(userId, type, options).then((response) => {
      const collection = new UserCommissionCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserCommission();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public removeUserCommission(userId: number, scheduleId: number) {
    return this.webAPI.removeUserCommission(userId, scheduleId).then((response) => {
      return response;
    });
  }
}
